import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'

import type Report from '../../common/types/api/report'
import BarSettingsReport from '../../Form/components/Header/BarSettingsReport'
import { actionUpdateReport } from '../../actions/updateReports'
import { ReportContext } from '../../../src/app'
import updateReport from '../../api/updateReport'
import { Scheduling } from '../../Form/components/Scheduling/Scheduling'
import { MailSettingsInstance } from '../../common/types/api/report'

interface Props {
    match: {
        params: {
            uid: string
        }
    }
}

export function SchedulingSection({ match }: Props): JSX.Element {
    const { report, dispatch } = useContext(ReportContext)
    const [stateReport, setStateReport] = useState({
        loading: true,
        startLoading: false,
        msg: null
    })

    const uid = match?.params?.uid

    useEffect(() => {
        const reportUid = report?.uid

        const checkUpdateReport = (): boolean => {
            if (stateReport.startLoading) {
                return false
            } else {
                return stateReport.loading
            }
        }

        if (checkUpdateReport()) {
            setStateReport({
                loading: true,
                msg: null,
                startLoading: true
            })

            if (reportUid) {
                dispatch({ report: undefined })
            }

            actionUpdateReport(match.params.uid)
                .then(report => dispatch({ report }))
                .then(() => setStateReport({ loading: false, msg: 'success', startLoading: false }))
                .catch(error => {
                    console.log(error)
                    setStateReport({ loading: false, msg: error.message, startLoading: false })
                })
        }
    }, [match, report, stateReport, stateReport.loading, uid, stateReport.startLoading, dispatch])

    if (stateReport.loading) return <div>loading...</div>
    if (stateReport.msg !== 'success') return <div>{stateReport.msg}</div>

    const setReport = (report: Report): void => {
        updateReport({ ...report }).then(res => dispatch({ report: res.config }))
    }
    
    return (
        <div>
            <BarSettingsReport pageName="scheduling" uid={uid} />
            <Scheduling
                formObject={(() => {
                    return report
                })()}
                onChange={(schedulingJobs: MailSettingsInstance[]) => {
                    report.isDraft = true

                    const newReport = { ...report }
                    newReport.mailSettings.mailSettingsInstances = [...schedulingJobs]
                    setReport({ ...newReport })
                }}
            />
            <Separator />
        </div>
    )
}

const Separator = styled.div`
    margin-top: 30px;
`
